import * as PIXI from "pixi.js";
import {pixiComponents} from "../index";
import {CANVAS} from "../constants/configs";
import {spinStore, store} from "../store";
import {createButton} from "./index";
import {cpConfigs} from "./configs";
import {gsap} from "gsap";
import {getAmountWithCurrency, universalClick} from "../utilites";
import {coinSound} from "../soundService";
import {SmoothGraphics} from '@pixi/graphics-smooth';
import {t, TKeys} from "../translationService";

export const showBetSettingsSection = () => {
    pixiComponents.cpItems.betSettingsSection.visible = true;

    pixiComponents.cpItems.betSettingsSection.scale.set(0.3);

    gsap.to(pixiComponents.cpItems.betSettingsSection.scale, {
        y: 1,
        x: 1,
        duration: 0.05,
    });
}
export const hideBetSettingsSection = () => pixiComponents.cpItems.betSettingsSection.visible = false;

let currentSpinAmountIndex = 3;

export const setSpinAmount = (newIndex) => {
    if (newIndex < 0 || newIndex >= spinStore.quickBets.length) {
        return;
    }
    currentSpinAmountIndex = newIndex;
    spinStore.setSpinAmount(spinStore.quickBets[currentSpinAmountIndex]);

    amountText.text = getAmountWithCurrency(spinStore.spinAmount, store.currency);

}

export const betSettingsSectionUi = {
    width: 420,
    height: 275,
    checkBox: {x: 25, y: 90, size: 46, fontSize: 34},
    amountChanger: {x: 0, y: 180},
}

export const addBetSettingsSection = () => {
    const betSettingsContainer = new PIXI.Container();
    betSettingsContainer.visible = false;

    betSettingsContainer.pivot.y = betSettingsSectionUi.height;

    betSettingsContainer.x = cpConfigs.spinBtn.x - betSettingsSectionUi.width / 2;
    betSettingsContainer.y = cpConfigs.spinBtn.y - cpConfigs.spinBtn.height / 1.7;

    pixiComponents.betSettingsContainer = betSettingsContainer;
    betSettingsContainer.addChild(createBetSettingsSectionBg(), createBetSettingsSectionHeader());
    betSettingsContainer.addChild(createCheckbox((bool) => spinStore.setIsTurboMode(bool), {
        x: betSettingsSectionUi.checkBox.x,
        y: betSettingsSectionUi.checkBox.y,
        size: betSettingsSectionUi.checkBox.size,
        fontSize: betSettingsSectionUi.checkBox.fontSize,
        labelText: t(TKeys.TURBO_SPIN),
    }));
    betSettingsContainer.addChild(createSpinAmountChanger());

    return betSettingsContainer;
}

const createBetSettingsSectionHeader = () => {
    const headerContainer = new PIXI.Container();

    const title = new PIXI.Text(t(TKeys.BET_SETTINGS), {fontFamily: "BebasNeue", fontSize: 37, fill: 0xffffff});
    title.x = betSettingsSectionUi.width / 2;
    title.y = 23;
    title.anchor.set(0.5, 0);

    const closeBtn = createButton({
        textureName: "close.png",
        x: betSettingsSectionUi.width - 30,
        y: 25,
        width: 50,
        height: 50
    });

    universalClick(closeBtn, hideBetSettingsSection);

    headerContainer.addChild(title, closeBtn);
    return headerContainer;
}

const createBetSettingsSectionBg = () => {
    const bgContainer = new PIXI.Container();

    const rect = new PIXI.Graphics();
    rect.beginFill("rgba(0,0,0,0.0001)");
    rect.drawRect(-1500, -1500, 3000, 3000);
    rect.endFill();
    rect.eventMode = 'static';
    universalClick(rect, hideBetSettingsSection)

    bgContainer.addChild(rect);

    const graphics = new PIXI.Graphics();
    graphics.eventMode = "static";

    const lineWidth = 1;
    const lineColor = "rgba(0,0,0,0.1)";
    const fillColor = "rgba(0,0,0,0.9)";

    const width = betSettingsSectionUi.width;//250;
    const height = betSettingsSectionUi.height;//150;
    const x = 0//cpConfigs.spinBtn.x;
    const y = 0//cpConfigs.spinBtn.y;
    const borderRadius = 15;

    graphics.lineStyle(lineWidth, lineColor);
    graphics.beginFill(fillColor);
    graphics.drawRoundedRect(x, y, width, height, borderRadius);
    graphics.endFill();

    bgContainer.addChild(graphics);

    return bgContainer;
}

let amountText = null;
export let updatePlusMinusButtonsOpacity = () => {};

const createSpinAmountChanger = () => {
    const spinAmountChanger = new PIXI.Container();
    spinAmountChanger.x = betSettingsSectionUi.amountChanger.x;
    spinAmountChanger.y = betSettingsSectionUi.amountChanger.y;

    const minusButton = createButton({
        textureName: "minus.png",
        x: 50,
        y: 35,
        width: 75,
        height: 75,
    });

    const plusButton = createButton({
        textureName: "plus.png",
        x: 369,
        y: 35,
        width: 75,
        height: 75,
    });

    amountText = new PIXI.Text(`${spinStore.spinAmount}`, {fill: 0xD9D9D9, fontSize: 34, fontFamily: "BebasNeue"});
    amountText.anchor.set(0.5);
    amountText.x = betSettingsSectionUi.width / 2;
    amountText.y = 35;

    const rect = new SmoothGraphics();
    rect.lineStyle(2, 0xD9D9D9);
    rect.beginFill(0x0A0911);
    rect.drawRoundedRect(amountText.x, 5, 195, 60, 12);
    rect.endFill();

    rect.pivot.x = 195 / 2;
    spinAmountChanger.addChild(rect, amountText, minusButton, plusButton)

    updatePlusMinusButtonsOpacity = (spinAmount) => {
        minusButton.alpha = 1;
        minusButton.eventMode = "static";
        plusButton.alpha = 1;
        plusButton.eventMode = "static";
        if (spinStore.quickBets[0] === spinAmount) {
            minusButton.alpha = 0.4;
            minusButton.eventMode = "auto";
        } else if (spinStore.quickBets[spinStore.quickBets.length - 1] === spinAmount) {
            plusButton.alpha = 0.4;
            plusButton.eventMode = "auto";
        }
    }

    universalClick(minusButton, () => {
        setSpinAmount(currentSpinAmountIndex - 1)
        coinSound.play();
    });

    universalClick(plusButton, () => {
        setSpinAmount(currentSpinAmountIndex + 1)
        coinSound.play();
    });

    return spinAmountChanger;
}

const createCheckbox = (
    onChange = () => {
    },
    {
        x = 0,
        y = 0,
        labelText = 'Label',
        size = 26,
        lineWidth = 4,
        checkboxColor = 0x000000,
        fontFamily = "BebasNeue",
        fontSize = 23,
        textColor = 0xffffff,
    },
) => {
    const checkBoxContainer = new PIXI.Container();
    checkBoxContainer.eventMode = "static";
    checkBoxContainer.cursor = 'pointer';
    checkBoxContainer.x = x;
    checkBoxContainer.y = y;

    const checkbox = new SmoothGraphics();
    checkbox.lineStyle(2, 0xffffff);
    checkbox.beginFill(checkboxColor);
    checkbox.drawRoundedRect(0, 0, size, size, 4);
    checkbox.endFill();

    const labelStyle = {
        fontFamily,
        fontSize,
        fill: textColor,
    }

    const label = new PIXI.Text(labelText, labelStyle);
    label.anchor.set(0, 0.5)
    label.x = size * 1.2;
    label.y = size / 2;

    universalClick(checkBoxContainer, handleCheckboxClick);

    let isChecked = false;

    function handleCheckboxClick() {
        isChecked = !isChecked;
        checkbox.clear();
        checkbox.lineStyle(2, 0xffffff);
        if (isChecked) {
            checkbox.beginFill(0xffffff);
            checkbox.drawRoundedRect(0, 0, size, size, 4);
            checkbox.endFill();

            checkbox.lineStyle(lineWidth, 0x000000);
            checkbox.moveTo(lineWidth, size / 2);
            checkbox.lineTo(size / 2.5, size - lineWidth);
            checkbox.lineTo(size - lineWidth, lineWidth);
            checkbox.endFill();
        } else {
            checkbox.beginFill(checkboxColor);
            checkbox.drawRoundedRect(0, 0, size, size, 4);
            checkbox.endFill();
        }
        onChange(isChecked);
    }

    checkBoxContainer.addChild(label);
    checkBoxContainer.addChild(checkbox);
    return checkBoxContainer;
}



